export default () => ({
  admissions: [],
  admissionsTotal: 0,
  practitionerAdmissions: [],
  practitionerAdmissionsTotal: 0,
})
